<template>
  <div>

    <!-- radio -->
    <el-radio-group v-model="radioValue" v-if="type=='radio'" @change="radioChange">
      <el-radio v-for="(item,index) in dataList" :key="index" :label="item.Code">{{item.Name}}</el-radio>
    </el-radio-group>

    <!-- checkbox -->
    <el-checkbox-group v-model="checkValue" v-if="type=='checkbox'" @change="checkboxChange">
      <el-checkbox v-for="(item,index) in dataList" :key="index" :label="item.Code">{{item.Name}}</el-checkbox>
    </el-checkbox-group>

    <!-- select单选 -->
    <el-select v-model="selectValue" filterable placeholder="请选择" v-if="type=='select' && !this.multiple" @change="selectChange">
      <el-option v-for="(item,index) in dataList" :key="index" :value="item.Code" :label="item.Name"></el-option>
    </el-select>

    <!-- select多选 -->
    <el-select v-model="multipleselectValue" filterable placeholder="请选择" multiple v-if="type=='select' && this.multiple" @change="selectChange">
      <el-option v-for="(item,index) in dataList" :key="index" :value="item.Code" :label="item.Name"></el-option>
    </el-select>

  </div>
</template>

<script>
export default {
  name: "DicSelect",
  props: {
    value: {
      type: [String,Number],
      default: "",
    }, type: {//类型（radio、checkbox、select）
      type: String,
      default: "select",
    }, dicCode: {
      type: String,
      default: ''
    }, multiple: {
      type: Boolean,
      default: false
    }, labelType: {
      type: String,//文字显示的类型（name：名称，namecode：名称+代码,code：代码）
      default: 'name'
    }, valueType: {
      type: String,//文字显示的类型（name：名称，,code：代码）
      default: 'code'
    }
  },
  mounted() {
    this.setValue();
    this.loadList();
  },
  watch: {
    value(newval, oldval)//监听值的变化，防止组件首次渲染之后，不在加载mounted方法。导致不刷新
    {
      if (this.thisValue != newval) {
        this.setValue();
      } else {
        this.thisValue = "";
        this.setValue();
      }
    }
  },
  data() {
    return {
      thisValue: '',//最后选择的值，为了再修改父组件的值时不请求接口
      radioValue: '',//
      checkValue: [],//
      selectValue: '',//
      multipleselectValue: [],//select 多选时的值
      dataList: [],//{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}
    }
  },
  methods: {
    setValue() {
      switch (this.type) {
        case 'radio':
          this.radioValue = this.value.toString();
          break;
        case 'checkbox':
          let arr=this.value.split(",");
            let newArr=[];
          arr.forEach (item=>{newArr.push(item.toString())});
          this.checkValue =newArr;
          break;
        case 'select':
          if (this.multiple) {
            let arr=this.value.split(",");
            let newArr=[];
          arr.forEach (item=>{newArr.push(item.toString())});
            this.multipleselectValue = newArr;
          } else {
            this.selectValue = this.value.toString();
          }
          break;
      }
    },
    loadList() {//加载文件列表    
      this.http.post('api/Sys_Dic/GetDicListByCode?Code=' + this.dicCode, {}, true).then((x) => {
        if (x.Code) {
          let list = [];
          x.Data.forEach(item => {
            list.push({ Name: item.Name, Code: item.Code, OldName: item.Name, OldCode: item.Code });
          });

          if (this.labelType != 'name') {
            list.forEach(item => {
              if (this.labelType == 'namecode') {
                item.Name = item.OldName + '(' + item.OldCode + ')';
              } else {
                item.Name = item.OldCode;
              }
            });
          }

          if (this.valueType == 'name') {
            list.forEach(item => {
              item.Code = item.OldName;
            });
          }

          this.dataList = list;
        } else {
          return this.$message.error(x.Message);
        }
      });
    }, updateUrl(value) {//修改父组件的值
      //this.$emit('update:value', v.join(','));//用：value.sync时需要改变父组件的值
      this.thisValue = value;
      this.$emit('input', value);//用v-model时需要改变父组件的值
    }, radioChange(value) {
      this.updateUrl(value);
    }
    , checkboxChange(valueArr) {
      this.updateUrl(valueArr.join(","));
    }, selectChange(value) {
      if (this.multiple) {
        this.updateUrl(multiple.join(","));
      } else {
        this.updateUrl(value);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DicSelect.vue